export default __webpack_public_path__ + "static/media/logo-large.5b2f3271.png";